export default "/region.3d18d78f-148bd9.png";